const MARKET_FORMATS = {
    US: { locale: 'en-US', currency: 'USD' },
    UK: { locale: 'en-GB', currency: 'GBP' },
    AU: { locale: 'en-AU', currency: 'AUD' },
    DE: { locale: 'de-DE', currency: 'EUR' }
}

export const getMarketPriceFormat = () => {
    const country = document.documentElement.dataset.country || 'US'
    return MARKET_FORMATS[country] || {
        locale: document.documentElement.dataset.locale || 'en-US',
        currency: document.documentElement.dataset.currency || 'USD'
    }
}

export const createPriceFormatter = currency => {
    const market = getMarketPriceFormat()
    return new Intl.NumberFormat(market.locale, {
        style: 'currency',
        currency: currency || market.currency
    })
}
